import { forwardRef } from "react";
import SvgIcon from "@mui/material/SvgIcon";
import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgResources = forwardRef((props, ref) => {
	return React.createElement(SvgIcon, {
		...props,
		ref
	}, /* @__PURE__ */ _jsx("path", {
		fill: "none",
		d: "M18.751 3.00024C19.9445 3.00024 21.089 3.47435 21.933 4.31826C22.7769 5.16218 23.251 6.30677 23.251 7.50024C23.251 8.69372 22.7769 9.83831 21.933 10.6822C21.089 11.5261 19.9445 12.0002 18.751 12.0002H5.25098C4.0575 12.0002 2.91291 11.5261 2.069 10.6822C1.22508 9.83831 0.750977 8.69372 0.750977 7.50024C0.750977 6.30677 1.22508 5.16218 2.069 4.31826C2.91291 3.47435 4.0575 3.00024 5.25098 3.00024H18.751Z",
		stroke: "currentcolor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "none",
		d: "M18.751 12.0002C19.3419 12.0002 19.9271 12.1166 20.4731 12.3428C21.019 12.5689 21.5151 12.9004 21.933 13.3183C22.3508 13.7361 22.6823 14.2322 22.9084 14.7782C23.1346 15.3241 23.251 15.9093 23.251 16.5002C23.251 17.0912 23.1346 17.6764 22.9084 18.2223C22.6823 18.7683 22.3508 19.2644 21.933 19.6822C21.5151 20.1001 21.019 20.4316 20.4731 20.6577C19.9271 20.8838 19.3419 21.0002 18.751 21.0002H5.25098C4.0575 21.0002 2.91291 20.5261 2.069 19.6822C1.22508 18.8383 0.750977 17.6937 0.750977 16.5002C0.750977 15.3068 1.22508 14.1622 2.069 13.3183C2.91291 12.4744 4.0575 12.0002 5.25098 12.0002H18.751Z",
		stroke: "currentcolor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M10.501 7.50024H18.751",
		stroke: "currentcolor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M10.501 16.5002H18.751",
		stroke: "currentcolor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M4.5 7.87524C4.29289 7.87524 4.125 7.70735 4.125 7.50024C4.125 7.29314 4.29289 7.12524 4.5 7.12524",
		stroke: "currentcolor",
		strokeWidth: 1.5
	}), /* @__PURE__ */ _jsx("path", {
		d: "M4.5 7.87524C4.70711 7.87524 4.875 7.70735 4.875 7.50024C4.875 7.29314 4.70711 7.12524 4.5 7.12524",
		stroke: "currentcolor",
		strokeWidth: 1.5
	}), /* @__PURE__ */ _jsx("path", {
		d: "M4.5 16.8752C4.29289 16.8752 4.125 16.7074 4.125 16.5002C4.125 16.2931 4.29289 16.1252 4.5 16.1252",
		stroke: "currentcolor",
		strokeWidth: 1.5
	}), /* @__PURE__ */ _jsx("path", {
		d: "M4.5 16.8752C4.70711 16.8752 4.875 16.7074 4.875 16.5002C4.875 16.2931 4.70711 16.1252 4.5 16.1252",
		stroke: "currentcolor",
		strokeWidth: 1.5
	}));
});
export default SvgResources;
